export const EMPLOYEE_GROUPS_QUERY_KEY = 'employeeGroups'
export const ARCHIVED_EMPLOYEE_GROUPS_QUERY_KEY = 'archivedEmployeeGroups'
export const EMPLOYEE_GROUPS_BRIEFS_QUERY_KEY = 'employeeGroupsBriefs'
